var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBlobbo = function SvgBlobbo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 371,
    height: 410,
    viewBox: "0 0 371 410",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M145.623 353.637c-21.953-2.904-39.721-27.432-59.743-50.379-20.31-23.114-20.245-4.845-33.932-34.127v-135.5c18.593-19.627 38.555-12.956 70.398-34.912 31.616-21.895 53.259-62.84 84.086-77.69 30.887-14.622 71.184-3.21 86.085 26.967 14.84 29.95 4.118 78.952 10.501 114.584 6.672 35.799 30.283 58.517 42.947 91.246 12.953 32.896 15.123 75.515-7.755 88.235-22.712 12.431-70.761-5.203-107.658-4.835-37.064.657-62.975 19.315-84.929 16.411Z",
    fill: "#F7F3F0"
  })));
};
export default SvgBlobbo;